import { useState, useCallback } from 'react';
import type { StatusFilter, ManagerFilter } from '@src/models/enterprise-inquiry';

export function useEnterpriseInquiryFilters() {
  // 실제 검색에 사용되는 값 (검색 버튼/엔터 시에만 업데이트)
  const [searchTerm, setSearchTermState] = useState('');
  // 사용자가 입력 중인 값 (실시간 업데이트)
  const [searchInput, setSearchInputState] = useState('');
  const [statusFilter, setStatusFilterState] = useState<StatusFilter>('all');
  const [managerFilter, setManagerFilterState] = useState<ManagerFilter>('all');

  // 검색 입력값 변경 (실시간)
  const setSearchInput = useCallback((value: string) => {
    setSearchInputState(value);
  }, []);

  // 실제 검색 실행 (검색 버튼/엔터 시)
  const executeSearch = useCallback(() => {
    setSearchTermState(searchInput);
  }, [searchInput]);

  const setStatusFilter = useCallback((value: StatusFilter) => {
    setStatusFilterState(value);
  }, []);

  const setManagerFilter = useCallback((value: ManagerFilter) => {
    setManagerFilterState(value);
  }, []);

  const resetFilters = useCallback(() => {
    setSearchTermState('');
    setSearchInputState('');
    setStatusFilterState('all');
    setManagerFilterState('all');
  }, []);

  return {
    searchTerm, // API 쿼리에 사용
    searchInput, // UI 입력필드에 사용
    statusFilter,
    managerFilter,
    setSearchInput,
    executeSearch,
    setStatusFilter,
    setManagerFilter,
    resetFilters,
  };
}

